module.exports = __webpack_public_path__ + "img/junior.a45a7c04.jpg";